import { render, staticRenderFns } from "./cowDeletion.vue?vue&type=template&id=e0cca114&scoped=true&"
import script from "./cowDeletion.vue?vue&type=script&lang=js&"
export * from "./cowDeletion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0cca114",
  null
  
)

export default component.exports